import { SvgIconProps } from "@mui/material";
import { ThemedFillSvgIcon } from "src/theme-mui/components/svg-icon/themed-fill-svg-icon";
// eslint-disable-next-line no-restricted-imports
import { InfoSvg } from "../icons/info";

export const IconInfo = ({ ...props }: SvgIconProps) => (
    <ThemedFillSvgIcon {...props} viewBox="0 0 24 24">
        <InfoSvg />
    </ThemedFillSvgIcon>
);
